import { SpecificationsLibrary } from '@/components/specifications/SpecificationsLibrary';

export default function SpecificationsPage() {
  return (
    <div className="container mx-auto max-w-7xl">
      <SpecificationsLibrary />
    </div>
  );
}
